import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "react-image-gallery/styles/css/image-gallery.css";
import "../components/stylesheets/home.css";
import { Link, useNavigate } from "react-router-dom";
import SeaBreeze from "../components/img/1.jpg";
import DinerthCottage from "../components/img/Annex/AnnexMain1.jpeg";
import Art from "../components/img/Art/Workshop1.jpeg";
import Navigation from "../nav/Navbar";

const Home = () => {
  const navigate = useNavigate(); // Get the navigate function

  return (
    <>
      <Navigation />
      <Container className="mt-5">
        <h1>The Welsh Riviera</h1>
        <p>
          Welcome to the Welsh Riviera on the magnificent coast of stunning
          North Wales. We have two properties to offer visitors which cater for
          most needs.
        </p>
        <Row className="text-center">
          <Col md={4}>
            <Link to="/sea-breeze" className="image-link">
              <div className="image-card">
                <img
                  src={SeaBreeze}
                  alt="Sea Breeze main"
                  className="owner-image img-fluid equal-height"
                />
                <h5 className="image-title">Sea Breeze</h5>
              </div>
            </Link>
          </Col>
          <Col md={4}>
            <Link to="/dinerth-cottage" className="image-link">
              <div className="image-card">
                <img
                  src={DinerthCottage}
                  alt="Dinerth Cottage main"
                  className="owner-image img-fluid equal-height"
                />
                <h5 className="image-title">Dinerth Cottage</h5>
              </div>
            </Link>
          </Col>
          <Col md={4}>
            <a
              href="https://ginnyhelsen.co.uk/lessons-and-workshops"
              target="_blank"
              rel="noopener noreferrer"
              className="image-link"
            >
              <div className="image-card">
                <img
                  src={Art}
                  alt="Art"
                  className="owner-image img-fluid equal-height"
                />
                <h5 className="image-title">Art Showcase</h5>
              </div>
            </a>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Home;
